// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import Content from './content';
import { getDetailImage } from "~/util/cdn";
import { deferPromise } from "~/util/general";
import { CONFIG } from "~/config";

/**
 * @class Hlavní obrázek detailu
 * @private
 */
export default class WebCam extends Content {
	getPosterData() {
		return this._promiseData.promise;
	}

	handleEvent(e) {
		e.preventDefault();
		Mapy.getComponent("webcam").activate().setData(this._data.webcam, this._data.title);
		Mapy.getComponent("history").save();
	}

	_build() {
		this._promiseData = deferPromise();

		if (this._data.webcam && this._data.webcam.length) {
			var first = this._data.webcam[0];
			var photo = first.urls["16x9"] ? first.urls["16x9"] : null;

			if (photo) {
				const url = getDetailImage(photo);

				var link = document.createElement("a");
				link.setAttribute("href", "https://" + CONFIG.BASE_URL + "/?source=" + this._data.source + "&id=" + this._data.id + "&webcam=1");
				link.addEventListener("click", this, false);
				link.setAttribute("id", "webcam-cont");

				var img = document.createElement("img");
				img.classList.add("image-holder");
				img.src = url;

				var live = node("img", {src:"/img/webcam-live.png", className:"webcam-live"});

				link.appendChild(img);
				link.appendChild(live);

				this._dom.container = link;
				this._promiseData.resolve([link, "webcam"]);
			}
		} else {
			this._promiseData.reject({});
		}
	}
}
